import DataLoading from './DataLoading'

class Aep {
  constructor(jsonAep) {
    // map des props du json
    Object.assign(this, jsonAep)
  }
}

class AepsPool {
  categs = []

  activeAtStart = {}

  constructor() {
    this.get = this.get.bind(this)
  }

  init() {
    let aepCategs = []
    let prevName = null
    let currentCateg = null

    DataLoading.aeps.forEach(jsonAep => {

      if(jsonAep.category !== prevName){
        prevName = jsonAep.category

        currentCateg = {
          name: jsonAep.category,
          aeps: []
        }
        aepCategs.push(currentCateg)
      }

      let aep = new Aep(jsonAep)
      currentCateg.aeps.push(aep)

      if(aep.active_at_start) {
        this.activeAtStart[aep.category] = aep.id
      }
    })

    this.categs = aepCategs
  }

  applyScenario(scenario) {
    this.activeAtStart = {...this.activeAtStart, ...scenario.initial_aeps}

    if(scenario.models) {

      scenario.models.forEach(model => {
        let [aepIdToReplace, newId] = model

        // remove de l'aep
        if(newId === null || newId === "") {
          let aepcateg = this.getAepCateg(aepIdToReplace)
          aepcateg.aeps = aepcateg.aeps.filter(aep => aep.id !== aepIdToReplace)
        }
      })
    }
  }

  applyTranslations() {
    if(!DataLoading.aepsTranslations) return
    DataLoading.aepsTranslations.forEach(t => {
      const aep = this.get(t.id)
      if(t.title) aep.title = t.title
      if(t.description) aep.description = t.description
    })
  }


  overrideAepTitle(aepId, otherAepId) {
    let aep = this.get(aepId)
    let otherAep = this.get(otherAepId)
    if(aep && otherAep) {
      aep.title = otherAep.title
    }
  }

  // utlilisé pour les rules
  getAepName(aepId) {
    const aep = this.get(aepId)
    if(aep) return aep.title
    return null
  }

  getCateg(categid) {
    return this.categs.find(c => c.name === categid)
  }

  getAepCateg(id) {
    for(let i in this.categs) {
      let c = this.categs[i]
      for(let j in c.aeps) {
        if(c.aeps[j].id === id) return c
      }
    }
    return null
  }


  get(id) {
    for(let i in this.categs) {
      let c = this.categs[i]
      for(let j in c.aeps) {
        if(c.aeps[j].id === id) return c.aeps[j]
      }
    }
    return null
  }
}



export default new AepsPool()
